var PublicModule = /** @class */ (function () {
    function PublicModule() {
    }
    return PublicModule;
}());
export { PublicModule };
